import { Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { cellStyle, orderSummaryDetailCellStyles, tableInRowStyle } from "./OrderSummaryTableStyles";
import React from "react";
import { grey } from "@mui/material/colors";
import { stripTrailingZeros } from "../../../../../utils/decimal";

const priceTableColumnSx = {
  fontSize: 18,
};

export const SummaryDetailRow = ({detail}) => (
  <Grid container columnSpacing={2} my={2}>
    <Grid item xs
      sx={{ ...priceTableColumnSx, ...orderSummaryDetailCellStyles.customerShopName }}
    >
      {detail.customerName + " " + detail.shopName}
    </Grid>

    <Grid item xs
      sx={{ ...priceTableColumnSx, ...orderSummaryDetailCellStyles.unitQuantity }}
    >
      {detail.orderingUnitQuantity}
    </Grid>

    <Grid item xs
      sx={{ ...priceTableColumnSx, ...orderSummaryDetailCellStyles.orderQuantity, textAlign: "right"}}
    >
      {stripTrailingZeros(detail.orderQuantity)}
    </Grid>
          
    <Grid item xs
      sx={{ ...priceTableColumnSx, ...orderSummaryDetailCellStyles.orderingUnitName}}
    >
      {detail.orderingUnitName}
    </Grid>
  </Grid> 
     
);

